import styled from "styled-components";
import { IconButton } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PageTitle = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const ActionToolbar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;

  button {
    font-size: 14px;
    padding: 8px 16px;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
  padding: 0;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MainImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
  background-color: #f8f9fa;
  border-radius: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const MenuButton = styled(IconButton)`
  padding: 6px;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const MainImageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
`;

export const ImagesTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AdditionalImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
  }
`;

export const ImageCard = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`;

export const MenusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MenusGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

export const MenuUrl = styled.div`
  word-break: break-word;
  font-size: 12px;
  color: #666;
  margin: 8px 0;
`;

export const TextAreaField = styled.div`
  grid-column: 1 / -1;
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
